import React from 'react';

export default function DashboardFilter ({ onFilterClick, currentFilter })  {
  return (
    <div className="flex justify-end mb-1">
      <button
        onClick={onFilterClick}
        className="flex items-center gap-2 px-4 py-2 bg-white border border-gray-300 rounded-lg shadow-sm hover:bg-gray-50"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 text-gray-500" viewBox="0 0 20 20" fill="currentColor">
          <path fillRule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clipRule="evenodd" />
        </svg>
        <span className="text-sm font-medium text-gray-700 capitalize">
          {`${currentFilter.month} ${currentFilter.year}`}
        </span>
      </button>
    </div>
  );
};
